import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';

$w.onReady(function () {
  $w('#box2').onClick(() => {
            const biFields = {
                button_name: $w('#btnLp').label,
                additional_info: 'hp banner',
                topic: 'HP JP',
                url: wixLocation.url,
                target_url: $w('#btnLp').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })
});